import { Card, Link, Grid, Text, HStack } from '@postenbring/hedwig-react'

export const ArticleRows = ({ articleRows, heading, text }) => {

    return (
        <>
            {heading && <Text variant='h2' className='hds-mb-20-24'>{heading}</Text>}
            {text && <Text variant='body' className='hds-mb-20-24'>{text}</Text>}
            {articleRows.length > 0 && (
                <Grid gap='20-24' span={{ initial: 12, large: 6, xlarge: 4 }}>
                    {articleRows.map((article) => (
                        <Card variant='slim' color='lighter-brand' key={article.url}>
                            {article.imgUrl && (
                                <Card.Media>
                                    <Card.MediaImg src={article.imgUrl} alt={article.imgAltText} />
                                </Card.Media>
                            )}
                            <Card.Body>
                                <Card.BodyHeader as='h3'>
                                    <Card.BodyHeaderTitle>
                                        {article.title}
                                    </Card.BodyHeaderTitle>
                                </Card.BodyHeader>
                                {article.preface && (
                                    <Card.BodyDescription>
                                        {article.preface}
                                    </Card.BodyDescription>
                                )}
                                <Card.BodyAction>
                                    <Link href={article.url} variant='solid' aria-label={article.linkText}>
                                        <Card.BodyActionArrow />
                                        {article.linkText}
                                    </Link>
                                </Card.BodyAction>
                            </Card.Body>
                        </Card>
                    ))}
                </Grid>
            )}
        </>
    )
}
